import { getClerkInstance } from '../auth/clerkAuth';
export async function botRequest(path='', method='GET', body) {
    const auth=getClerkInstance();
    const owner=auth?.user?.id;
    const unchanged=()=>{if(owner!==getClerkInstance()?.user?.id)throw new Error('Account changed. Try again.');};
    const token=await auth?.clerkInstance?.session?.getToken();
    unchanged();
    if(!token)throw new Error('Sign in to manage server bots.');
    try {
    const response=await fetch((process.env.VUE_APP_API_BASE||'')+'/api'+path,{method,headers:{Authorization:'Bearer '+token,'Content-Type':'application/json'},body:body===undefined?undefined:JSON.stringify(body)});
    const data=await response.json();
    unchanged();
    if(!response.ok)throw new Error(data.error||'Server request failed.');
    return data;
    } catch(error) { unchanged(); throw error; }
}
